import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import moment from 'moment';
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { reportPreviewActions, report } from '../../lossAss/actions'

class OpenChat extends Component {
	constructor(props) {
		super(props)
		this.state = {
			curCheckStyle: 0
		}
	}
	componentDidMount() {
		const { actions, customer } = this.props
		actions.currentCustomerInfo(customer);
		//actions.saveInfoBut(true)
	}
	handleClick(data) {
		const { customer, actions } = this.props;
		actions.getCreateReport('update')
		actions.changeActiveReportTab('1')
		actions.getCurrentReport(customer.userInfo.flowId)
		this.props.history.push(`/workBench/ReportDetail/${customer.userInfo.flowId}`)
	}
	render() {
		const { customer } = this.props

		let timeHour = '', timeYear = '', timeDiv
		if (customer && customer.startedAt) {

			timeHour = moment(customer.startedAt).format('HH:mm')
			timeYear = moment(customer.startedAt).format('MM/DD')

		}
		if (timeYear && timeHour) {
			timeDiv = <div className="time-div-history">{timeYear + ' ' + timeHour}</div>
		}
		return <li
			className={`list-item ${(customer.unreadCount ? 'unread' : '')}`}
			onClick={this.handleClick.bind(this, customer._id)}
			key={customer._id}
		>
			<h4>
				<span className="name">{customer.userInfo.carOwner}</span>
				<span className="number">{customer.userInfo.flowId}</span>
			</h4>
			<div className="time">{timeDiv}</div>
		</li>
	}
}
class OpenChatList extends Component {
	componentDidMount() {
	}
	render() {
		const { actions, dashboard, list } = this.props;

		return  <ul className='list'>
				{
					list.map(customer => <OpenChat
						key={customer._id}
						customer={customer}
						actions={actions}
						history={this.props.history}
						dashboard={dashboard} />
					)
				}
			</ul>
	}
}

/**
 * Props that OpenChatList component expects to be passed.
 */
OpenChatList.propTypes = {
	// Count to be displayed on header
	count: PropTypes.number.isRequired,
	// List title
	title: PropTypes.string.isRequired,
	// List icon url
	icon: PropTypes.string,
	// Bool of whether the agent is in a call.
	customers: PropTypes.array
}

/**
 * Default props when OpenChatList isn't passed any prop.
 */
OpenChatList.defaultProps = {
	count: 0,
	title: '',
	icon: '',
	customers: []
}


let mapDispatchToProps = (dispatch) => {
	return {
			reportPreviewActions: bindActionCreators(Object.assign({},

					reportPreviewActions,
					report

			), dispatch)
	}
};

export default connect(
	null,
	mapDispatchToProps
)(withRouter(OpenChatList))
